// Function loadStepByStepContainerBlock loads the StepByStepContainerBlock class by dynamically importing the js on demand if needed

export function loadStepByStepContainerBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-step-by-step-container-block-chunk" */ '../widgets/stepByStepContainerBlock').then(wg => {

		const { StepByStepContainerBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="StepByStepContainerBlock"]');

		if(!$wg) {
			// console.info('StepByStepContainerBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="StepByStepContainerBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new StepByStepContainerBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new StepByStepContainerBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the StepByStepContainerBlock widget');

}
